import { Box, Checkbox, FormControlLabel, Grid, IconButton, ListItemIcon, ListItemText, MenuItem, TextField, Typography } from '@material-ui/core'
import { useEffect, useMemo, useState } from 'react'
import { ArrowLeft } from 'react-feather'

const ComponentConfiguration = ({ config, setConfig, assets = [] }) => {
  const [selectedProperties, setSelectedProperties] = useState([])
  const [assetName, setAssetName] = useState('')
  const [assetId, setAssetId] = useState(null)

  const back = () => {
    setConfig(null)
  }

  const handleAssetSelection = (asset = null) => {
    const newAssetId = assetId === asset.uuid ? null : asset.uuid
    if (newAssetId) {
      setAssetId(newAssetId)
      setConfig(prevConfig => ({
        ...prevConfig,
        assetId: newAssetId,
        assetType: asset?.assetType?.name
      }))
    }
  }

  const handleAssetName = (e) => {
    setAssetName(e.target.value)
    setConfig(prevConfig => ({
      ...prevConfig,
      assetName: e.target.value
    }))
  }

  const handlePropertySelection = (e) => {
    let newSelectedProperties = selectedProperties
    const selectedPropertiesValues = selectedProperties.map(prop => prop.value)

    if (e.target.checked && !selectedPropertiesValues?.includes(e.target.name)) {
      const currentAsset = assets.find(asset => asset.uuid === assetId)
      if (currentAsset) {
        newSelectedProperties = [...selectedProperties, { value: e.target.name, label: (currentAsset?.propertyMappings ?? {})[e.target.name]?.propertyName ?? '-' }]
      }
    } else if (!e.target.checked && selectedProperties?.includes(e.target.name)) {
      newSelectedProperties = [...selectedProperties.filter(prop => prop.value !== e.target.name)]
    }

    setSelectedProperties(newSelectedProperties)
    setConfig(prevConfig => ({
      ...prevConfig,
      assetProperties: newSelectedProperties
    }))
  }

  useEffect(() => {
    if (config.assetId) {
      setSelectedProperties(config.assetProperties ?? [])
      setAssetName(config.assetName ?? '')
      setAssetId(config.assetId)
    }
  }, [config])

  const selectedAsset = useMemo(() => assets.find(asset => asset.uuid === assetId), [assetId, assets])
  const propertyMapping = selectedAsset?.propertyMappings ?? {}
  const assetProperties = Object.keys(propertyMapping)
    .filter(key => key !== 'status')
    .map(key => ({ propKey: key, label: propertyMapping[key]?.propertyName }))

  return (
    <Box width='100%'>
      <Box display='flex' alignItems='center'>
        <IconButton size='small' style={{ marginRight: 8 }} onClick={back}>
          <ArrowLeft />
        </IconButton>
        <Typography variant='h6'>Configura componente</Typography>
      </Box>
      <Grid container spacing={1} style={{ marginTop: 8 }}>
        <Grid item xs={12} md={6}>
          <TextField
            fullWidth
            size='small'
            variant='outlined'
            label='Nome componente'
            placeholder='Nome'
            value={assetName}
            onChange={handleAssetName}
          />
        </Grid>
        <Grid item xs={12} md={6}>
          <TextField
            size='small'
            color='primary'
            variant='outlined'
            select
            fullWidth
            SelectProps={{
              displayEmpty: true,
              renderValue: (renderSelected) => (
                <ListItemText style={{ marginTop: 0, marginBottom: 0 }}>
                  {assets?.find(asset => asset.uuid === renderSelected)?.name || ''}
                </ListItemText>)
            }}
            label='Seleziona dispositivo da associare'
            value={assetId ?? ''}
          >
            {assets?.length === 0
              ? <MenuItem value={null} disabled>Non ci sono dispositivi disponibili</MenuItem>
              : (assets || []).map(el => (
                <MenuItem
                  dense
                  onClick={() => handleAssetSelection(el)}
                  key={el.uuid}
                  value={el.uuid}
                >
                  <ListItemIcon>
                    <Checkbox
                      color='primary'
                      edge='start'
                      checked={el.uuid === config.asset?.uuid}
                      disableRipple
                    />
                  </ListItemIcon>
                  <ListItemText>{el.name}</ListItemText>
                </MenuItem>
                ))}
          </TextField>
        </Grid>
      </Grid>
      {assetId && (
        <Box mt={2}>
          <Typography variant='h6'>Seleziona le proprietà da visualizzare</Typography>
          <Grid container spacing={0}>
            {assetProperties.map(el => (
              <Grid item xs={12} md={4} key={el.propKey}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectedProperties?.map(prop => prop.value).includes(el.propKey)}
                      onChange={handlePropertySelection}
                      name={el.propKey}
                      color='primary'
                    />
                }
                  label={el.label}
                />
              </Grid>
            ))}
          </Grid>
        </Box>
      )}
    </Box>
  )
}

export default ComponentConfiguration
